import React, { lazy } from 'react';
import { MapPin, Instagram } from 'lucide-react';
export function Location() {
  return <section className="w-full py-20 px-4 bg-[#111111]" data-id="element-62">
      <div className="max-w-6xl mx-auto" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-64">
          <div className="flex flex-col space-y-8" data-id="element-65">
            <div data-id="element-66">
              <h2 className="font-display text-4xl md:text-5xl font-bold uppercase tracking-wide mb-4" data-id="element-67">
                Nuestra <span className="text-gold" data-id="element-68">Ubicación</span>
              </h2>
              <p className="text-muted text-lg" data-id="element-69">
                Visítanos en nuestra barbería y escuela.
              </p>
            </div>

            <div className="bg-background border border-gold p-8 rounded-lg flex items-start space-x-4" data-id="element-70">
              <MapPin className="text-gold w-8 h-8 flex-shrink-0 mt-1" data-id="element-71" />
              <div data-id="element-72">
                <h3 className="font-display text-2xl font-bold uppercase mb-2" data-id="element-73">
                  Dirección
                </h3>
                <p className="text-lg" data-id="element-74">C.M Ramírez 1528 esq. Vigo</p>
                <p className="text-muted" data-id="element-75">Montevideo, Uruguay</p>
              </div>
            </div>

            <a href="https://instagram.com/pueblobarber" target="_blank" rel="noopener noreferrer" className="bg-background border border-[#333333] hover:border-gold p-8 rounded-lg flex items-center space-x-4 transition-colors group" data-id="element-76">
              <Instagram className="text-muted group-hover:text-gold w-8 h-8 flex-shrink-0 transition-colors" data-id="element-77" />
              <div data-id="element-78">
                <h3 className="font-display text-2xl font-bold uppercase mb-1" data-id="element-79">
                  Síguenos
                </h3>
                <p className="text-gold text-lg" data-id="element-80">@pueblobarber</p>
              </div>
            </a>
          </div>

          <div className="h-[500px] w-full rounded-lg overflow-hidden border-2 border-gold" data-id="element-81">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3273.194519548486!2d-56.2346781!3d-34.8764022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f800000000001%3A0x0!2zMzTCsDUyJzM1LjAiUyA1NsKwMTQnMDQuOCJX!5e0!3m2!1sen!2suy!4v1700000000000!5m2!1sen!2suy" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Mapa de ubicación de Pueblo Barber" data-id="element-82"></iframe>
          </div>
        </div>
      </div>
    </section>;
}